import { Device } from '@capacitor/device';
import { logger } from 'features/logger/logger';
import { callDebugInfo } from 'features/questionnaires/services/proseService';
import {
  allInfoCollected,
  deviceInfoLoaded,
  proseInfoLoaded,
  windowIdGenerated,
} from './systemInfoSlice';
import type { AppPromiseThunk } from 'features/store/store';

export const loadSystemInfo = (): AppPromiseThunk => async dispatch => {
  const proseInfo = await callDebugInfo();
  logger.info('PROSE info:', { details: proseInfo });
  // Not everything in proseInfo is serializable
  dispatch(proseInfoLoaded({ version: proseInfo.version }));

  const capacitorDeviceInfo = await Device.getInfo();
  logger.info('Capacitor device info:', { details: capacitorDeviceInfo });

  const capacitorDeviceId = await Device.getId();
  logger.info('Capacitor device id:', { details: capacitorDeviceId });

  dispatch(
    deviceInfoLoaded({
      id: capacitorDeviceId.identifier,
      ...capacitorDeviceInfo,
    })
  );

  const windowId = crypto.randomUUID();
  logger.info(`windowId set to: ${windowId}`);
  dispatch(windowIdGenerated(windowId));

  dispatch(allInfoCollected());
};
